import {labels, tax} from '../../quote-tool/globals/config';
import {idgUrl} from '../../global/apiProxy';
import {vehicleSelectorData} from './vehicleSelector';
import {apSwitchStep} from '../components/apSwitchStep';
import toolLoader from '../components/toolLoader';
import {menaPrice} from '../../components/tools';
import apAnalytics from '../components/apAnalytics';
import analyticsErrors from '../components/analyticsErrors';

const $ = jQuery;
const $allServices = $('.js-service-selector--service');

/**
 * Service selector data
 * @type {{totalDuration: number, totalPrice: number, items: *[]}}
 */
export let serviceSelectorData = {
    items: [],
    totalPrice: 0,
    totalDuration: 0,
};

/**
 * Service selector module
 */
export function serviceSelectorModule() {
    toggleOperations();
    serviceSelect();
    conditionCheckbox();
    submitModule();
    scrollToCondition();
}

/**
 * Toggle operations modal
 */
function toggleOperations() {
    const $trigger = $('.c-ap-service-selector__service-info');

    $trigger.on('click', function (e) {
        const $this = $(this);
        const $modal = $this.siblings('.js-ap-diagnosis-service-modal');

        // If modal-overlay does not exist then create it right after body
        if (!$('.modal-overlay').length) {
            $('.c-ap-service-selector').append('<div class="modal-overlay"></div>');
        }

        // Toggle active class on modal overlay
        $('.modal-overlay').toggleClass('active');


        if (!$modal.hasClass('active')) {
            $modal.slideDown(300).addClass('active');
        } else {
            $modal.slideUp(300).removeClass('active');
             $('.modal-overlay').removeClass('active');
        }
    });

    // Close modal on click outside of modal on click
    $(document).on('click', function (e) {
        const $modal = $('.js-ap-diagnosis-service-modal');

        if ((!$modal.is(e.target) && $modal.has(e.target).length === 0) && (!$trigger.is(e.target) && $trigger.has(e.target).length === 0)) {
            $modal.slideUp(300).removeClass('active');
            $('.modal-overlay').removeClass('active');
        }
    });

    // Close modal on click outside of modal on click
    $('.js-ap-diagnosis-service-modal-close').on('click', function (e) {
        $('.js-ap-diagnosis-service-modal').slideUp(300).removeClass('active');
        $('.js-ap-diagnosis-service-modal-kilometers').slideUp(300).removeClass('active');
        $('.modal-overlay').removeClass('active');
    });
}

/**
 * Select service
 */
function serviceSelect() {
    const notAllowedClasses = ['c-ap-service-selector__service-info', 'js-ap-diagnosis-service-modal', 'js-ap-diagnosis-service-modal-close', 'c-qt-diagnosis__service-modal-items'];
    const $kilometersModal = $('.js-ap-diagnosis-service-modal-kilometers');

    $allServices.on('click', function (e) {
        if (notAllowedClasses.some(className => e.target.classList.contains(className))) return;

        $(this).toggleClass('active');
        let serviceId = $(this).data('service-api-id');
        let serviceType = $(this).data('service-type');
        const isFixed = $(this).data('service-fixed');

        if (!serviceType) {
            serviceType = '';
        }

        // If service is fixed then just add it to the list
        if (isFixed) {
            getAllActiveServicesData();
            setDataInSidebar();
            return;
        }

        if (serviceId) {
            let pass = true;

            if ($(this).data('require-kilometers') && !vehicleSelectorData.mileage) {
                $kilometersModal.data('service-id', serviceId);
                $kilometersModal.slideDown(300).addClass('active');
                pass = false;
            }

            if (pass) {
                if (!$(this).data('service-price')) {
                    toolLoader();

                    if (serviceType === 'grand') {
                        if (vehicleSelectorData.fuelType === 'D') {
                            serviceId = 100101;
                        }
                        if (vehicleSelectorData.fuelType === 'E') {
                            serviceId = 100102;
                        }
                    }

                    loadServiceData(serviceId, serviceType);
                } else {
                    getAllActiveServicesData();
                    setDataInSidebar();
                }
            }
        }
    });

    $('.js-ap-diagnosis-service-modal-kilometers--submit').on('click', function () {
        let $kilometerModal = $(this).closest('.js-ap-diagnosis-service-modal-kilometers');

        if ($kilometerModal.hasClass('active')) {
            checkKilometers($kilometerModal);
        }
    });
}

function checkKilometers($modal) {
    const serviceId = $modal.data('service-id');
    const $service = $(`.js-service-selector--service[data-service-api-id="${serviceId}"]`);
    const $mileageParent = $modal.find('.c-qt-vehicle-select__form-input');
    const $mileageError = $modal.find('.js-ap-vehicle-selector-error-message');
    const $mileageInput = $mileageParent.find('#mileage');
    const mileage = $mileageInput.val();

    if (mileage) {
        vehicleSelectorData.mileage = mileage;
        $('#mileage').val(mileage);

        $modal.slideUp(300).removeClass('active');
        $service.removeClass('has-required');
        $service.removeClass('active');
        $service.trigger('click');
    } else {
        if (!$mileageParent.hasClass('error')) {
            $mileageParent.addClass('error');
            $mileageError.text(labels.emptyField).show();
        }
    }

}

/**
 * Load service data
 * @param serviceId of the service
 * @param serviceType type of the service
 */
function loadServiceData(serviceId, serviceType = '') {
    let $service = $(`.js-service-selector--service[data-service-api-id="${serviceId}"]`);

    if (serviceType === 'grand') {
        $service = $(`.js-service-selector--service[data-service-type="grand"]`);
    }

    // The proxy builds the price request body (live garage) server side.
    let data = {
        vehicleId: vehicleSelectorData.vehicleId,
        serviceId: serviceId,
    };
    if (vehicleSelectorData.mileage) {
        data.kilometers = vehicleSelectorData.mileage;
        data.releaseDate = vehicleSelectorData.releaseDate;
    }

    const settings = {
        async: true,
        url: idgUrl('quote'),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        data: data,
    };

    $.ajax(settings).done(function (response) {
        if (response.data) {
            const serviceData = response.data[0];

            if (serviceData.price.maxPriceExclTax) {
                $service.data('service-price', serviceData.price.maxPriceExclTax);
                $service.data('service-duration', serviceData.duration);
                getAllActiveServicesData();
                setDataInSidebar();
            }
        }

        if (response.errors.vehicle) {
            alert(menaObject.service_not_found);
            $service.removeClass('active').addClass('disabled');
        }

        toolLoader(true);
    }).fail(function (response) {
        // Your error handling logic here
        if (response.responseJSON) {
            console.log(response.responseJSON.detail);
            analyticsErrors('vehicle-info', 3, 'system-error', '', response.responseJSON.detail);
            alert(menaObject.service_not_found);
            $service.removeClass('active').addClass('disabled');
        }
        toolLoader(true);
    });
}

/**
 * Get all active services data
 */
function getAllActiveServicesData() {
    const $activeServices = $('.js-service-selector--service.active');
    let services = [];

    $activeServices.each(function (i, service) {
        let price = $(service).data('service-price');
        price = price && price > 0 ? parseFloat(price) * tax : 0;
        price = price.toFixed(2);

        let duration = $(service).data('service-duration');
        duration = duration && duration > 0 ? parseFloat(duration) : 0;

        let serviceData = {
            id: $(service).data('service-id'),
            apiId: $(service).data('service-api-id'),
            price: parseFloat(price),
            name: $(service).data('service-name'),
            engName: $(service).data('service-name-eng'),
            duration: parseFloat(duration),
        };
        services.push(serviceData);
    });

    serviceSelectorData.items = services;
    serviceSelectorData.totalPrice = calculateServicesTotalPrice();
    serviceSelectorData.totalDuration = calculateServicesTotalDuration();

    validateModule();
}

/**
 * Calculate services total price
 * @returns {number}
 */
function calculateServicesTotalPrice() {
    let totalPrice = 0;

    serviceSelectorData.items.forEach(function (service) {
        totalPrice += service.price;
    });

    return totalPrice;
}

/**
 * Calculate services total duration
 * @returns {number}
 */
function calculateServicesTotalDuration() {
    let totalDuration = 0;

    serviceSelectorData.items.forEach(function (service) {
        totalDuration += service.duration;
    });

    return totalDuration;
}

/**
 * Set data in sidebar
 */
function setDataInSidebar() {
    const $totalPrice = $('.js-tool-sidebar--total');
    const $totalDuration = $('.js-tool-sidebar--duration');
    const $servicesList = $('.js-tool-sidebar--items.services');

    // Set items
    $servicesList.empty();
    serviceSelectorData.items.forEach(function (service) {
        $servicesList.append(
            $('<li>').addClass('tool-sidebar__flex').append(
                $('<span>').addClass('font-medium').text(service.name),
                $('<span>').addClass('price').text(menaPrice(service.price, false)),
            ),
        );
    });

    $totalPrice.text(menaPrice(serviceSelectorData.totalPrice));
    $totalDuration.text(formatDuration(serviceSelectorData.totalDuration));
}

/**
 * Format duration
 * @param minutes
 * @returns {string}
 */
export function formatDuration(hours) {
    let hoursPart = Math.floor(hours);
    let minutesPart = Math.round((hours % 1) * 60);
    return hoursPart + 'h' + (minutesPart > 0 ? minutesPart : '');
}

/**
 * Scroll to condition
 *
 * @param {string} selector
 *
 *
    */
function scrollToCondition() {
    const serviceSubmit = $('.js-service-selector--submit');

    if(serviceSubmit) {
        serviceSubmit.on('click', function() {
            const $conditionCheckbox = $('#ap-schedule-privacy-checkbox');
            if (!$conditionCheckbox.is(':checked')) {
                $conditionCheckbox[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    }
}

/**
 * Validate module
 * @returns {boolean}
 */
function validateModule() {
    let valid = true;

    const $submitBtn = $('.js-service-selector--submit');
    const checkbox = document.querySelector('#ap-schedule-privacy-checkbox');

    if (serviceSelectorData.items.length === 0 || !checkbox.checked) {
		valid = false;
	}

    if (valid && $submitBtn.hasClass('c-button--disabled')) {
        $submitBtn.removeClass('c-button--disabled');
    } else if (!valid && !$submitBtn.hasClass('c-button--disabled')) {
        $submitBtn.addClass('c-button--disabled');
    }

    return valid;
}

/**
 * Condition checkbox
 */
function conditionCheckbox() {
    const $checkbox = $('#ap-schedule-privacy-checkbox');

    $checkbox.on('change', function () {
        validateModule();
    });
}

/**
 * Submit module
 */
function submitModule() {
    const $submitBtn = $('.js-service-selector--submit');

    $submitBtn.on('click', function () {
        if (validateModule()) {
            let services = [];

            serviceSelectorData.items.forEach(function (service) {
                if (service.engName) {
                    services.push(service.engName);
                } else {
                    services.push(service.name);
                }
            });

            apAnalytics('choose-service--submit', services);
            apSwitchStep('replacement');
        }
    });
}
